import { render } from "./OvApplicationsLane.vue?vue&type=template&id=5c18dcac&scoped=true"
import script from "./OvApplicationsLane.vue?vue&type=script&lang=js"
export * from "./OvApplicationsLane.vue?vue&type=script&lang=js"

import "./OvApplicationsLane.vue?vue&type=style&index=0&id=5c18dcac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c18dcac"]])

export default __exports__